import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/home.vue';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter);
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
  },
  {
    path: '/administrators',
    name: 'Administrators',
    component: () => import('@/views/administrators/index.vue'),
  },
  {
    path: '/events',
    name: 'Events',
    component: () => import('@/views/events/index.vue'),
  },
  {
    path: '/administrators/new',
    name: 'New administrator',
    component: () => import('@/views/administrators/create.vue'),
  },
  {
    path: '/administrators/remove',
    name: 'Remove administrator confirmation',
    component: () => import('@/views/administrators/remove.vue'),
  },
  {
    path: '/administrators/add',
    name: 'Add administrator confirmation',
    component: () => import('@/views/administrators/add.vue'),
  },
  {
    path: '/applications',
    name: 'Applications',
    component: () => import('@/views/applications/index.vue'),
  },
  {
    path: '/applications/pending',
    name: 'Applications pending approval',
    component: () => import('@/views/applications/pending.vue'),
  },
  {
    path: '/applications/:id',
    name: 'Application',
    component: () => import('@/views/applications/show.vue'),
  },
  {
    path: '/businesses',
    name: 'Businesses',
    component: () => import('@/views/enterprise/index.vue'),
  },
  {
    path: '/businesses/create',
    name: 'BusinessesCreate',
    component: () => import('@/views/enterprise/create.vue'),
  },
  {
    path: '/businesses/unbilled',
    name: 'BusinessesListUnbilled',
    component: () => import('@/views/enterprise/unbilled.vue'),
  },
  {
    path: '/businesses/:id/customer',
    name: 'Business customer',
    component: () => import('@/views/billing-customers/show.vue'),
  },
  {
    path: '/businesses/:id/subscription',
    name: 'Business subscription',
    component: () => import('@/views/subscriptions/show.vue'),
  },
  {
    path: '/businesses/:id/subscription/manage',
    name: 'Business subscription manage',
    component: () => import('@/views/subscriptions/manage.vue'),
  },
  {
    path: '/businesses/:id/subscription/assign',
    name: 'Business subscription assign',
    component: () => import('@/views/subscriptions/assign.vue'),
  },
  {
    path: '/businesses/:id',
    name: 'Business',
    component: () => import('@/views/enterprise/show.vue'),
  },
  {
    path: '/documents',
    name: 'Documents',
    component: () => import('@/views/Documents/Index.vue'),
  },
  {
    path: '/documents/:id',
    name: 'DocumentsShow',
    component: () => import('@/views/Documents/Index.vue'),
  },
  {
    path: '/deleted-documents',
    name: 'DeletedDocuments',
    component: () => import('@/views/DeletedDocuments/Index.vue'),
  },
  {
    path: '/deleted-documents/:id',
    name: 'DeletedDocumentsShow',
    component: () => import('@/views/DeletedDocuments/Show.vue'),
  },
  {
    path: '/promotions',
    name: 'PromotionsIndex',
    component: () => import('@/views/PromocodeCampaigns/Index.vue'),
  },
  {
    path: '/promotions/:id',
    name: 'PromotionsShow',
    component: () => import('@/views/PromocodeCampaigns/Show.vue'),
  },
  {
    path: '/promotions/:id/redeemed',
    name: 'PromotionsShowRedeemed',
    component: () => import('@/views/PromocodeCampaigns/Redeemed.vue'),
  },
  {
    path: '/billing-products/:id/create-price',
    name: 'BillingProductsCreatePrice',
    component: () => import('@/views/billing-products/create-price.vue'),
  },
  {
    path: '/billing-products/create',
    name: 'BillingProductsCreate',
    component: () => import('@/views/billing-products/create.vue'),
  },
  {
    path: '/billing-products/:id',
    name: 'BillingProductsShow',
    component: () => import('@/views/billing-products/show.vue'),
  },
  {
    path: '/billing-products',
    name: 'BillingProductsIndex',
    component: () => import('@/views/billing-products/index.vue'),
  },
  {
    path: '/billing-prices/:id/edit',
    name: 'BillingPricesEdit',
    component: () => import('@/views/billing-prices/edit.vue'),
  },
  {
    path: '/billing-prices/:id',
    name: 'BillingPricesShow',
    component: () => import('@/views/billing-prices/show.vue'),
  },
  {
    path: '/subscriptions/past-due',
    name: 'SubscriptionsListPastDue',
    component: () => import('@/views/subscriptions/past-due.vue'),
  },
  {
    path: '/invoices/list-open',
    name: 'InvoicesListOpen',
    component: () => import('@/views/invoices/list-open.vue'),
  },
  {
    path: '/billing-provider/import',
    name: 'BillingProviderImport',
    component: () => import('@/views/billing-provider/import-list.vue'),
  },
  {
    path: '/billing-provider/product/:id/import-price',
    name: 'BillingProviderImportPrice',
    component: () => import('@/views/billing-provider/import-price.vue'),
  },
  {
    path: '/system-setting',
    name: 'SystemSetting',
    component: () => import('@/views/system-settings/smtp-provider.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
